export default __webpack_public_path__ + "static/media/Selleradminpanel.aedf6871.png";